import { DataSourceIcon } from '@/lib';
import { DataSource } from '@/models/dataSource';
import { FC } from 'react';
import { DataSourceCardLabel } from './DataSourceCardLabel';
import { DataSourceOverviewCard } from './DataSourceOverviewCard';

type DataSourceTypeCardProps = {
  isLoading: boolean;
  dataSource: DataSource;
};

export const DataSourceTypeCard: FC<DataSourceTypeCardProps> = ({ dataSource, isLoading }) => {
  return (
    <DataSourceOverviewCard title='overview.data_source_type' isLoading={isLoading}>
      <div className='flex items-center gap-4'>
        <DataSourceIcon type={dataSource.type.id} className='size-8' />
        <DataSourceCardLabel label={dataSource.type.name} />
      </div>
    </DataSourceOverviewCard>
  );
};
